import moment from 'moment-timezone';
import _sortBy from 'lodash/sortBy';
import _omit from 'lodash/omit';
import * as Types from 'pages/Features/tabs/Profile/TimezoneAndWorkHours/typings';

interface Props {
  workHoursByDay: Types.WorkHoursByDay;
  hoursEnabled: boolean;
  locationEnabled: boolean;
}

function getWorkHoursByDayArray({ workHoursByDay, hoursEnabled, locationEnabled }: Props) {
  const workHoursItems = Object.values(workHoursByDay);
  const workingDays = workHoursItems.filter(item => !!item);

  if (!workingDays.length) {
    return [];
  }

  const sortedWorkingDays = workingDays.sort((a: any, b: any) => a.day - b.day);
  return sortedWorkingDays.map((item: any) => {
    let itemToSave = item;

    if (!hoursEnabled || (!item.startTime && !item.endTime)) {
      itemToSave = _omit(item, ['startTime', 'endTime']);
    }
    if (!locationEnabled) {
      itemToSave = _omit(item, 'location');
    }

    if (hoursEnabled && item.startTime && item.endTime) {
      const startTimeMoment = moment(item.startTime);
      const endTimeMoment = moment(item.endTime);
      const startTimeHour = startTimeMoment.hour();
      const startTimeMinute = startTimeMoment.minute();
      const endTimeHour = endTimeMoment.hour();
      const endTimeMinute = endTimeMoment.minute();

      return {
        ...itemToSave,
        startTime: {
          hour: startTimeHour,
          minute: startTimeMinute,
        },
        endTime: {
          hour: endTimeHour,
          minute: endTimeMinute,
        },
      };
    } else {
      return itemToSave;
    }
  });
}

export default getWorkHoursByDayArray;
